import { render, staticRenderFns } from "./SplashPage.vue?vue&type=template&id=7a7efb52&scoped=true&"
import script from "./SplashPage.vue?vue&type=script&lang=js&"
export * from "./SplashPage.vue?vue&type=script&lang=js&"
import style0 from "./SplashPage.vue?vue&type=style&index=0&id=7a7efb52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a7efb52",
  null
  
)

component.options.__file = "SplashPage.vue"
export default component.exports